import { FormItem } from "element-ui";
// check表用来判断长度
const check = { 1: 1, 2: 1, 3: 1, 4: 1, 10: 1, 11: 1, 12: 1, 13: 1, 5: 0, 6: 0, 8: 0, 9: 0, 7: 2, 14: 2 }
export function resetdata(data) {
  console.log(data);
  let flag = 1
  var newdata = []
  let myit=[]
  try {
    data.data.forEach(item => {
      // 为0的初次为0
      let ndata = { act: item.type, clusterid: item.clusterid ? item.clusterid : 0, datasourceid: item.datasourceid ? item.datasourceid : 0, formula: '', targettable: item.id }
      let arr = []
      item.data.forEach(it => {
        let con = {}
        console.log(it.rules.act, it.rules.opeation, it.rules.limit)
        if (
          !it.rules.act ||
          (
            it.rules.act && !it.rules.opeation
          ) ||
          (
            it.rules.act && it.rules.opeation &&
            (
              check[it.rules.opeation] === 0 ? false : check[it.rules.opeation] === 1 ?
              (
                it.rules.limit[0] === '' ||
                it.rules.limit[0] === undefined ||
                it.rules.limit[0] === null||
                it.rules.limit[0] !== it.rules.limit[0]
              ) 
              :
              (
                it.rules.limit[0] === '' ||
                it.rules.limit[0] === undefined ||
                it.rules.limit[0] === null||
                it.rules.limit[0] !== it.rules.limit[0] ||
                it.rules.limit[1] === '' ||
                it.rules.limit[1] === undefined ||
                it.rules.limit[1] === null||
                it.rules.limit[1] !== it.rules.limit[1] 
              )
            )
          )
        ) {
          console.log(check[it.rules.opeation])
          myit=it.rules.limit
          throw new Error(-1)
        }
        console.clear()
        console.log(it.rules.limit)
        if (it.rules.limit.length == 2) {
          con = {
            fieldID: it.rules.act,
            sign: it.rules.opeation,
            value1: it.rules.limit[0],
            value2: it.rules.limit[1],
          }
        } else if (it.rules.limit.length == 1) {
          con = {
            fieldID: it.rules.act,
            sign: it.rules.opeation,
            value1: it.rules.limit[0],
            value2: 'null'
          }
        } else {
          con = {
            fieldID: it.rules.act,
            sign: it.rules.opeation,
            value1: 'null',
            value2: 'null'
          }
        }
        arr.push(con)
      })
      ndata.formula = JSON.stringify({ formulas: arr })
      newdata.push(ndata)
    });
  }
  catch (e) {
    console.log(e);
    flag = e.message
  }
  return flag == -1 ? {
      flag:-1,
      it:myit
  } : newdata
  // return newdata
}
export function expdata(rawdata) {
  let data = {
    type: 0,
    data: []
  }
  for (let i = 0; i < rawdata.length; i++) {
    let item = {
      id: rawdata[i].targettable,
      type: rawdata[i].act,
      data: [],
      clusterid: rawdata[i].clusterid,
      datasourceid: rawdata[i].datasourceid
    }
    let rawarr = JSON.parse(rawdata[i].formula).formulas
    rawarr.forEach((it, index) => {
      let c = []
      if (it.value1 || it.value1 === 0) {
        c = [it.value1]
      }
      if (it.value2 || it.value2 === 0) {
        c = [it.value1, it.value2]
      }
      console.clear()
      console.log(c)
      let item1 = {
        id: index,
        rules: { act: it.fieldID, opeation: it.sign, limit: c },
        data: {
          type: 0,
          children: []
        }
      }
      item.data.push(item1)
    })

    data.data.push(item)
  }
  return data
}


// WEBPACK FOOTER //
// ./src/utils/resetdata.js